// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__ou0nK","gfeWrapper":"CalendarEvent_gfeWrapper__TfAOc"};